/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BillingChangePreviewResponseCadence = typeof BillingChangePreviewResponseCadence[keyof typeof BillingChangePreviewResponseCadence];


export const BillingChangePreviewResponseCadence = {
  monthly: 'monthly',
  annual: 'annual',
} as const;
